"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANONICAL_MAIN_DASHBOARD_MODULE_IDS = void 0;
exports.splitDashboardModulesViewTokens = splitDashboardModulesViewTokens;
exports.mergeDashboardModulesOrder = mergeDashboardModulesOrder;
exports.normalizeDashboardModulesView = normalizeDashboardModulesView;
exports.sanitizeDashboardModulesOrder = sanitizeDashboardModulesOrder;
exports.CANONICAL_MAIN_DASHBOARD_MODULE_IDS = ["1", "2", "3", "4", "5", "6"];
function splitDashboardModulesViewTokens(value) {
    if (Array.isArray(value)) {
        return value.map(String).filter(Boolean);
    }
    if (typeof value !== "string") {
        return [];
    }
    const s = value.trim();
    if (!s) {
        return [];
    }
    if (s.includes(",")) {
        return s
            .split(",")
            .map(part => part.trim())
            .filter(Boolean);
    }
    return [...s];
}
function mergeDashboardModulesOrder(userTokens, canonicalIds) {
    const seen = new Set();
    const out = [];
    for (const id of userTokens) {
        if (id && !seen.has(id)) {
            seen.add(id);
            out.push(id);
        }
    }
    for (const id of canonicalIds) {
        if (!seen.has(id)) {
            seen.add(id);
            out.push(id);
        }
    }
    return out;
}
function normalizeDashboardModulesView(value, canonicalIds = exports.CANONICAL_MAIN_DASHBOARD_MODULE_IDS) {
    const tokens = splitDashboardModulesViewTokens(value);
    return mergeDashboardModulesOrder(tokens, canonicalIds).join(",");
}
function sanitizeDashboardModulesOrder(value, canonicalIds = exports.CANONICAL_MAIN_DASHBOARD_MODULE_IDS) {
    return mergeDashboardModulesOrder(splitDashboardModulesViewTokens(value), canonicalIds);
}
//# sourceMappingURL=dashboard-modules.js.map